<mat-tab-group class="full-height">
 <mat-tab label="Incoming" class="full-height">
  <app-lot-unknown class="full-height"></app-lot-unknown>
</mat-tab>
<mat-tab label="Isolate List" class="full-height">
  <app-lot-list class="full-height"></app-lot-list>
 </mat-tab>
</mat-tab-group>
